<template>
  <div class="">
        <div class="box-table">
          <div class="horizontal-responsive">
            <table class="table-investment">
              <tr>
                <th v-for="month in months.data"
                    :value="month.id"
                    :key="month.id" >{{month.alias}}
                </th>
                <th>Total Anual</th>
              </tr>
              <tr>
                <td>{{ formatCurrency(getTotal(list, 'Enero')) }}</td>
                <td>{{ formatCurrency(getTotal(list, 'Febrero')) }}</td>
                <td>{{ formatCurrency(getTotal(list, 'Marzo')) }}</td>
                <td>{{ formatCurrency(getTotal(list, 'Abril')) }}</td>
                <td>{{ formatCurrency(getTotal(list, 'Mayo')) }}</td>
                <td>{{ formatCurrency(getTotal(list, 'Junio')) }}</td>
                <td>{{ formatCurrency(getTotal(list, 'Julio')) }}</td>
                <td>{{ formatCurrency(getTotal(list, 'Agosto')) }}</td>
                <td>{{ formatCurrency(getTotal(list, 'Septiembre')) }}</td>
                <td>{{ formatCurrency(getTotal(list, 'Octubre')) }}</td>
                <td>{{ formatCurrency(getTotal(list, 'Noviembre')) }}</td>
                <td>{{ formatCurrency(getTotal(list, 'Diciembre')) }}</td>
                <td>{{ formatCurrency(yearlyTotal) }}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
</template>

<script>

import mixins from '@/mixins/'

export default {
  name: 'InvestorPerformanceOverview',
  props: {
    months: {
      type: Object,
      required: true
    },
    yearlyTotal: {
      type: Number,
      required: true
    },
    list: {
      type: Array,
      required: true
    }
  },
  mixins: [mixins],
  methods: {
    getTotal: function (list, month) {
      const amount = list.filter((tmpArray) => {
        if (tmpArray.month === month) {
          return tmpArray.total
        } else {
          return 0
        }
      })
      const realTotal = amount.length !== 0 ? amount[0].total : 0
      return realTotal
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/InvestorPerformance/InvestorPerformanceOverview.vue